import { render } from "./PlacesAutocomplete.vue?vue&type=template&id=23ff85fd"
import script from "./PlacesAutocomplete.vue?vue&type=script&lang=js"
export * from "./PlacesAutocomplete.vue?vue&type=script&lang=js"

import "./PlacesAutocomplete.vue?vue&type=style&index=0&id=23ff85fd&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__